import type { SVGProps } from "react";
import * as React from "react";

const SvgChrome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.17 9a1 1 0 1 0 0-2zM4.816 5.56a1 1 0 1 0-1.732 1zm2.858 8.94a1 1 0 1 0 1.732-1zm2.34 6.94a1 1 0 0 0 1.732 1zm6.312-6.94a1 1 0 1 0-1.732-1zM21 12a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zm3 9a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5zm-3 3a3 3 0 0 1-3-3H7a5 5 0 0 0 5 5zm-3-3a3 3 0 0 1 3-3V7a5 5 0 0 0-5 5zm3-3a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5zm9.17-2H12v2h9.17zM3.084 6.56l4.59 7.94 1.732-1-4.59-7.94zm8.662 15.88 4.58-7.94-1.732-1-4.58 7.94z"
    />
  </svg>
);
export default SvgChrome;
